import { Skeleton } from '@/components/ui/skeleton';

/**
 * Skeleton loading state for the home greeting.
 * Matches the exact dimensions of HomeGreeting to prevent layout shift.
 */
export function HomeGreetingSkeleton() {
  return (
    <div className="mb-4 -mx-4 relative">
      {/* Gradient background area - reserved space but no image shown */}
      <div className="absolute inset-x-0 bottom-0 h-32" aria-hidden="true" />
      {/* Text content skeleton */}
      <div className="relative z-10 px-4 py-6">
        <Skeleton className="h-6 w-12 mb-2" />
        <Skeleton className="h-[45px] w-32" />
      </div>
    </div>
  );
}
